var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-404-container"},[_c('img',{attrs:{"src":require("@/assets/images/404.svg")}}),_c('button',{on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$t("logout")))])])}
var staticRenderFns = []

export { render, staticRenderFns }